
import {
  Mixins, Component, Watch, Prop,
} from 'vue-property-decorator';
import {
  Select,
  Option,
  Upload,
  Dialog,
} from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/set';
import bModal from './bModal.vue';
import tableMixin from './tableMixin';

@Component({
  components: {
    bModal,
    Select,
    Option,
    Upload,
    Dialog,
  },
})
export default class tData extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/set/app:add',
    icon: 'plus',
    callback: this.handleAddCourseHour,
    log: {
      name: '机构管理 - 新增',
      component: 'org/mange/components/bModal',
    },
  }];

  private visible: boolean = false;

  private uploadVisible: boolean = false

  private modalTitle: string = '';


  reset(close:Boolean) {
    this.uploadVisible = false;
    // if (close) this.$emit('update:visible', false);
  }

  handleAddCourseHour() {
    this.visible = true;
    this.modalTitle = '添加软件配置';
  }

  handleUpdateForm(row) {
    this.modalTitle = '编辑软件配置';
    this.form = row;
    this.visible = true;
  }

  private row: any = []

  handleUploadImg(row) {
    this.row = row;
    this.uploadVisible = true;
  }

  handleBeforeUpload(file: any) {
    const data:FormData = new FormData();
    data.append('pid', this.row.pid);
    data.append('image', file);
    api.uploadAppImg(data).then((res: any) => {
      this.uploadVisible = false;
      this.getData();
    });
    return false;
  }

  handleSearchChange(title) {
    this.getData();
  }
}
